module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan1-2-57374642650b176e4e4de0de142c326a.webp";